import { getSiteConfig } from 'utils/SiteUtils';

export function IconLink(props) {
    return (
        <a href={props.href} className={'flex gap-2 items-center group transition-all leading-none ' + getSiteConfig().color['text-hover'] + ' ' + (props.className || '')}>
            {props.icon}
            <div className={'border-b border-transparent transition-all text-sm '+ getSiteConfig().color['border-hover']}>{props.value}</div>
        </a>
    )
}